function tabs() {
	const pageTabs = document.querySelectorAll('.page-tabs');
	const layoutTabs = document.querySelectorAll('.layout-tabs');
	pageTabs.forEach(function(e) {
		const tabButtons = e.querySelectorAll('.tab-button');
		const tabContent = e.querySelectorAll('.tab-content');
		if (tabContent.length > 0) {
			tabContent[0].classList.add('is-active');
			tabButtons[0].classList.add('is-active');
			tabButtons.forEach(function(e, i) {
				e.addEventListener('click', function() {
					tabContent.forEach(function(e) {
						e.classList.remove('is-active');
					});
					tabButtons.forEach(function(e) {
						e.classList.remove('is-active');
					});
					e.classList.add('is-active');
					tabContent[i].classList.add('is-active');
				});
			});
		}
	});
	layoutTabs.forEach(function(e) {
		const tabButtons = e.querySelectorAll('.tab-button');
		const tabContent = e.querySelectorAll('.tab-content');
		if (tabContent.length > 0) {
			tabContent[0].classList.add('is-active');
			tabButtons[0].classList.add('is-active');
			tabButtons.forEach(function(e, i) {
				e.addEventListener('click', function() {
					tabContent.forEach(function(e) {
						e.classList.remove('is-active');
					});
					tabButtons.forEach(function(e) {
						e.classList.remove('is-active');
					});
					e.classList.add('is-active');
					tabContent[i].classList.add('is-active');
				});
			});
		}
	});
}

tabs();
